import SectionHeading from "@/components/SectionHeading"

export default function LegalPage() {
  return (
    <div className="min-h-screen pt-24 lg:pt-32">
      <section className="section-padding pb-20">
        <SectionHeading
          badge="Informations légales"
          title="Mentions"
          highlight="legales"
        />

        <div className="max-w-3xl mx-auto space-y-8">
          <div className="card !p-8">
            <h3 className="text-lg font-bold text-white mb-3">Editeur du site</h3>
            <div className="text-sm text-slate-400 space-y-1.5">
              <p><span className="text-slate-300 font-medium">Raison sociale :</span> LJJ IT</p>
              <p><span className="text-slate-300 font-medium">Forme juridique :</span> SARL</p>
              <p><span className="text-slate-300 font-medium">Siege social :</span> Paris, Ile-de-France</p>
              <p><span className="text-slate-300 font-medium">Email :</span> contact@ljj-it.com</p>
              <p><span className="text-slate-300 font-medium">Telephone :</span> +33 1 23 45 67 89</p>
            </div>
          </div>

          <div className="card !p-8">
            <h3 className="text-lg font-bold text-white mb-3">Hébergement</h3>
            <p className="text-sm text-slate-400">
              Ce site est hébergé par Lumi. Les données sont stockées sur des serveurs sécurisés.
            </p>
          </div>

          <div className="card !p-8">
            <h3 className="text-lg font-bold text-white mb-3">Propriété intellectuelle</h3>
            <p className="text-sm text-slate-400 leading-relaxed">
              L'ensemble du contenu de ce site (textes, images, logos, éléments graphiques)
              est la propriété exclusive de LJJ IT ou de ses partenaires. Toute reproduction,
              représentation ou diffusion, même partielle, est interdite sans autorisation
              préalable écrite.
            </p>
          </div>

          <div className="card !p-8">
            <h3 className="text-lg font-bold text-white mb-3">Protection des données personnelles</h3>
            <p className="text-sm text-slate-400 leading-relaxed mb-3">
              Conformément au Règlement Général sur la Protection des Données (RGPD),
              vous disposez d'un droit d'accès, de rectification, de suppression et de
              portabilité de vos données personnelles.
            </p>
            <p className="text-sm text-slate-400 leading-relaxed">
              Les données collectées via les formulaires de contact et le système de
              ticketing sont utilisées exclusivement pour le traitement de vos demandes
              et ne sont jamais transmises à des tiers sans votre consentement.
            </p>
          </div>

          <div className="card !p-8">
            <h3 className="text-lg font-bold text-white mb-3">Cookies</h3>
            <p className="text-sm text-slate-400 leading-relaxed">
              Ce site utilise des cookies strictement nécessaires à son fonctionnement.
              Aucun cookie publicitaire ou de tracking n'est utilisé.
            </p>
          </div>

          <div className="card !p-8">
            <h3 className="text-lg font-bold text-white mb-3">Limitation de responsabilité</h3>
            <p className="text-sm text-slate-400 leading-relaxed">
              LJJ IT s'efforce de fournir des informations exactes et à jour sur ce site.
              Toutefois, LJJ IT ne peut garantir l'exactitude, la complétude ou l'actualité
              des informations diffusées. L'utilisation des informations et contenus
              disponibles sur ce site se fait sous l'entière responsabilité de l'utilisateur.
            </p>
          </div>
        </div>
      </section>
    </div>
  )
}
